import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const oddsAreaWrapper = css`
  display: block;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      display: grid;
      align-items: center;
      height: var(--ogm-grid-column-height);
    }
  }
`;

export const OddsAreaWrapperMobile = styled.div`
  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: var(--ogm-grid-column-height);
    }
  }
`;

export const OddsActionsWrapper = styled.div`
  display: flex;
  padding: 20px 15px 0 15px;
  height: 52px;
`;

export const activeBtn = css``;

export const Button = styled.button`
  display: flex;
  height: 32px;
  padding: 6px 10px 5px;
  border-radius: 5px;

  background: var(--oc-primary-white);
  color: var(--ogm-text-body);

  border: 1px solid var(--oc-border);

  transition: background 0.25s ease;

  &:not(:last-of-type) {
    margin-right: 10px;
  }

  &.${activeBtn} {
    background: var(--ogm-active-tab-bg-color);
    color: var(--ogm-active-tab-color);
    border: var(--ogm-active-tab-bg-color);
  }
`;

export const ButtonText = styled.span`
  font-family: var(--ogm-font-family-2);
  display: inline-block;
  font-style: normal;
  font-weight: 800;
  text-transform: var(--ogm-tab-text-transform);
  font-size: 14px;
  line-height: 19px;
  vertical-align: middle;
  transition: color 0.25s ease;
`;

export const OffersBadge = styled.span`
  display: inline-block;
  width: 18px;
  height: 17px;
  line-height: 19px;
  font-family: var(--ogm-font-family-2);
  font-style: normal;
  font-weight: 800;
  font-size: 10px;
  background: var(--ogm-grid-selected-cell-bg-color);
  text-align: center;
  color: var(--ogm-timberwolves);
  border-radius: 5px;
  vertical-align: middle;
  margin-left: 5px;
  transition:
    background 0.25s ease,
    color 0.25s ease;

  .${activeBtn} & {
    background: var(--ogm-title-bg-color-2);
    color: var(--ogm-grid-selected-cell-bg-color);
  }
`;

export const OffersMobileFallback = styled.div<{ bookmakersNumber: number }>`
  min-width: 100%;
  min-height: calc(${props => props.bookmakersNumber * 55} * 1px);
`;
